export default __webpack_public_path__ + "static/media/buster_klein_49.e55267a0.jpg";